import React from 'react'
import './phase-banner.scss'

// "Where am I" for a study split across three sittings, days apart.
//
// The full three-part overview is worth showing once, at the very start — it's how
// someone decides whether they can commit. Repeating it at the top of every part would
// be noise. After that they only need the one fact the overview can't carry: which part
// they're on now. Parts 2 and 3 otherwise open on a consent form and a recording gate,
// neither of which says.
const PARTS = [
  { phase: 'screening', n: 1, name: 'Warm-up session' },
  { phase: 'main', n: 2, name: 'Learning session' },
  { phase: 'followup', n: 3, name: 'Follow-up' }
]

export default function PhaseBanner ({ phase, compact }) {
  const part = PARTS.find(p => p.phase === phase)
  if (!part) return null

  return (
    <div className={`study-phase${compact ? ' study-phase--compact' : ''}`}>
      <span className="study-phase__label">
        Part {part.n} of 3{compact ? '' : ` · ${part.name}`}
      </span>
      <span className="study-phase__dots" aria-hidden="true">
        {PARTS.map(p => (
          <span
            key={p.phase}
            className={`study-phase__dot${p.n < part.n ? ' is-done' : ''}${p.n === part.n ? ' is-now' : ''}`}
          />
        ))}
      </span>
    </div>
  )
}
